(function ($) {
 'use strict';
 let timers = [];
 function trackedInterval(fn, ms) { const id = window.setInterval(fn, ms); timers.push(id); return id; }
 function initialize() {
  timers.forEach(window.clearInterval); timers = [];
  document.querySelectorAll('.nrsm-page .swiper').forEach(el => { if (el.swiper) el.swiper.destroy(true, true); });


$(document).ready(function(){

	$('.more-review').off('click.nrsm').on('click.nrsm', function(e) {
        e.preventDefault();
		$('.hide-review').fadeIn();
		$('.more-review-link').hide();
	});
	
	
	$('.qs-card').off('click.nrsm').on('click.nrsm', function(e) {
		$('.qs-card').removeClass('sel');
		$(this).addClass('sel');
	});


	//Thumb Swiper
	var thumbSwiper = new Swiper(".thumbSwiper", {
	  spaceBetween: 10,
	  slidesPerView:4,
	  freeMode: true,
	  watchSlidesProgress: true,
	  slideToClickedSlide: true, 
	  breakpoints: {
			0: {spaceBetween:4,},
			768: {spaceBetween:10,}
		
		  }
	
	});
	
	// Main Swiper
	var mainSwiper = new Swiper(".mainSwiper", {
	  spaceBetween: 10,
	  loop: true,
	  speed: 600,
	  thumbs: {
		swiper: thumbSwiper,
	  },
	  navigation: {
          nextEl: ".nav-slide-thumb .swiper-button-next",
          prevEl: ".nav-slide-thumb .swiper-button-prev",
        },
	});	
	
	thumbSwiper.on("click", function (swiper) {
		var clickedIndex = swiper.clickedIndex;
	
		if (clickedIndex === undefined) return;
	
		mainSwiper.slideToLoop(clickedIndex);
	
		var lastVisibleIndex = swiper.activeIndex + swiper.params.slidesPerView - 1;
	
		if (clickedIndex >= lastVisibleIndex) {
			swiper.slideNext();
		} else if (clickedIndex <= swiper.activeIndex) {
			swiper.slidePrev();
		}
	});	
	
	
	//Hero Feature Tab Review Slide
	var testimonialSwiper = new Swiper('.feature_tab-panel-review', {
		slidesPerView: 1.4,
		spaceBetween: 15,
		centeredSlides: false,
		loop: true,
	});
	
	
	//hero video slide
	var herovideoSwiper = new Swiper('.hero_videos_row', {
		slidesPerView: 3,
		spaceBetween: 10,
		centeredSlides: false,
		loop: true,
		
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		  
	});
	
	
	
	//hero_question_box
	$(".hero_question_heading").off('click.nrsm').on('click.nrsm', function () {
    
		var questionDiv = $(this);
		var answerDiv   = $(this).next(".hero_question_content");
		var idx         = $(".hero_question_content").index(answerDiv);
	
		// Desktop: 80px, Mobile: 50px
		var headerHeight = $(window).width() <= 767 ? 50 : 80;
	
		// Close other open answers
		$(".hero_question_content").each(function (index, ansDiv) {
			if (index != idx && $(ansDiv).is(":visible")) {
				$(ansDiv).stop(true, true).slideUp(500, function () {
					$(ansDiv)
						.prev(".hero_question_heading")
						.removeClass("hero_question_heading_open");
				});
			}
		});
	
		// Close current
		if (answerDiv.is(":visible")) {
	
			answerDiv.stop(true, true).slideUp(500, function () {
				questionDiv.removeClass("hero_question_heading_open");
	
				$("html, body").animate({
					scrollTop: questionDiv.offset().top - headerHeight
				}, 400);
			});
	
		} else {
	
			questionDiv.addClass("hero_question_heading_open");
	
			answerDiv.stop(true, true).slideDown(500, function () {
	
				$("html, body").animate({
					scrollTop: questionDiv.offset().top - headerHeight
				}, 400);
	
			});
		}
	});	
	
	
	// Benefits open independently and preserve the reader's scroll position.
    $('.benefit-accordion-heading').off('click.nrsm').on('click.nrsm', function(e) {
        e.preventDefault();
        var heading = $(this);
        var content = heading.next('.benefit-accordion-content');
        var opening = !content.is(':visible');
        heading.toggleClass('active', opening).attr('aria-expanded', String(opening));
        content.stop(true, true).slideToggle(200);
    });

	//ingredient_SLIDER
	var swiper = new Swiper(".ingredientSwiper", {
		loop: true,
		speed: 600,
		spaceBetween: 35,
		autoHeight: true,
		
		// Default (mobile first)
		slidesPerView: 1.2,
		centeredSlides: true,
		
		
		navigation: {
		nextEl: ".ingredientSwiper .swiper-button-next",
		prevEl: ".ingredientSwiper .swiper-button-prev",
		},
		
		breakpoints: {
		
		// 📱 Mobile
		0: { slidesPerView: 1.2, centeredSlides: true, spaceBetween:15, parallax:true,},
		
		// 📲 Small Tablet
		640: { slidesPerView:2, centeredSlides: true, spaceBetween: 20,},
		
		// 💻 Tablet
		768: { slidesPerView: 2.5, centeredSlides: true, spaceBetween:20,},
		
		// 🖥 Desktop
		1024: { slidesPerView: 3, centeredSlides: true, spaceBetween:30,},
		
		1300: { slidesPerView: 3.5, centeredSlides: true, spaceBetween:30,},
		1500: { slidesPerView: 4, centeredSlides: true, spaceBetween:30,},
		1700: { slidesPerView: 5, centeredSlides: true, spaceBetween:30,}
		}
	});
		
	
	//Modal Video
	var video = $('#myVdo video')[0];
	
	$('.ugc1').off('click.nrsm').on('click.nrsm', function(e) {
		var raw = this.getAttribute('data-nrsm-video-object'); var object = raw ? JSON.parse(raw) : null; var sources = object && object.sources; var source = sources && sources.find(s => s.mime_type === 'video/mp4'); var supplied = source ? source.url : $(this).attr('data-vdo'); if (!video || !supplied) { window.alert('This video has not been uploaded yet.'); return; } $('.ugc-modal').addClass('active');
		$('.video-container').show();
		
		var videoFile = supplied;
		video.src = videoFile;
		video.load();
		video.play().catch(function () {});
    });	
	
	$('.ugc-close, .ugc-modal').off('click.nrsm').on('click.nrsm', function(e) {
		if(!video) return; if(e.target.closest('.video-container') && !e.target.closest('.ugc-close')) return; video.pause(); video.src = '';
       	$('.ugc-modal').removeClass('active');
	   	$('.video-container').hide();
    });	
	
	
	//BUTTON_SCROLL
	$(".btn_scroll").off('click.nrsm').on('click.nrsm', function() {
		var offset = $(window).width() <= 767 ? 70 : 100; // 150 for mobile, 100 for desktop/tablet
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top - offset
		}, 2000);
	});
		
	
	//accordion JS 
	$(".accordion").off('click.nrsm').on('click.nrsm', function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.accordion').removeClass('accordion-open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
	});	
		
		
});


//Result_bar
var resultsTriggered = false;

$('#feature_tab-col-benefits').off('click.nrsm').on('click.nrsm', function () {

    if (resultsTriggered) {
        return;
    }

    resultsTriggered = true;

    setTimeout(function () {

        $('.result_box-row').each(function () {

            var value = $(this).attr('data-wdth');
            var $bar = $(this).find('.result_bar_inr');

            $bar.css('width', '0%');

            setTimeout(function () {
                $bar.css('width', value + '%');
            }, 50);

        });

        VanillaCounter();

    }, 100);

});


// COUNTER FUNCTION
function VanillaCounter() {
    let elements = document.querySelectorAll('.nrsm-page [data-vanilla-counter]');

    elements.forEach(i => {

        // Reset counter
        let start = parseInt(i.getAttribute('data-start-at')) || 0;
        let end = parseInt(i.getAttribute('data-end-at')) || 0;
        let delay = parseInt(i.getAttribute('data-delay')) || 0;
        let time = parseInt(i.getAttribute('data-time')) || 1000;

        let counter = start;
        let stepTime = Math.abs(Math.floor(time / (end - start)));

        i.innerHTML = counter;

        setTimeout(() => {
            let interval = trackedInterval(() => {

                counter += (end > start ? 1 : -1);
                i.innerHTML = counter;

                if (counter == end) {
                    clearInterval(interval);
                }

            }, stepTime);
        }, delay);
    });
}




$('.feature_tab-col').off('click.nrsmTabs').on('click.nrsmTabs', function () {
 $('.feature_tab-col').removeClass('active').attr('aria-selected', 'false');
 $('.feature_tab-panel').prop('hidden', true);
 $(this).addClass('active').attr('aria-selected', 'true');
 const panel = document.getElementById(this.getAttribute('aria-controls'));
 if (panel) panel.hidden = false;
});

// Use the visitor's calendar day and a real local-midnight cutoff.
function updateDeliveryClock() {
 const now = new Date();
 const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
 const remaining = Math.max(0, Math.ceil((tomorrow.getTime() - now.getTime()) / 1000));
 const hours = Math.floor(remaining / 3600);
 const minutes = Math.floor((remaining % 3600) / 60);
 const seconds = remaining % 60;
 $('.listicle-count').text(String(hours).padStart(2,'0') + 'h : ' + String(minutes).padStart(2,'0') + 'm : ' + String(seconds).padStart(2,'0') + 's');
 $('[data-nrsm-delivery-date]').text(tomorrow.toLocaleDateString('en-US', {month:'long', day:'numeric'}));
}
updateDeliveryClock();
trackedInterval(updateDeliveryClock, 1000);

//Top Timer
function getTimeRemaining(endtime) {
	  var t = Date.parse(endtime) - Date.parse(new Date());
	  var seconds = Math.floor((t / 1000) % 60);
	  var minutes = Math.floor((t / 1000 / 60) % 60);
	  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	  var days = Math.floor(t / (1000 * 60 * 60 * 24));
	  return {
		'total': t,
		'days': days,
		'hours': hours,
		'minutes': minutes,
		'seconds': seconds
	  };
	}
	
	function initializeClock(id, endtime) {
	  var clock = document.getElementById(id);
	 // var daysSpan = clock.querySelector('.days');
	  if (!clock) return;
 var hoursSpan = clock.querySelector('.hours');
	  var minutesSpan = clock.querySelector('.minutes');
	  var secondsSpan = clock.querySelector('.seconds');
	
	  function updateClock() {
		var t = getTimeRemaining(endtime);
	
	   // daysSpan.innerHTML = t.days;
		hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
		minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
		secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
	
		if (t.total <= 0) {
		  clearInterval(timeinterval);
		}
	  }
	
	  updateClock();
	  var timeinterval = trackedInterval(updateClock, 1000);
	}
	
	var deadline = new Date(Date.parse(new Date()) + 300 * 30 * 990);
	
	initializeClock('clockdiv', deadline);	


 $(document).off('scroll.nrsm').on('scroll.nrsm', function () { $('.nrsm-page .top-fix-bar').toggleClass('fixed-nav', $(document).scrollTop() > 110); });
 }
 $(initialize);
 document.addEventListener('shopify:section:load', function () { initialize(); });
 document.addEventListener('shopify:section:unload', function () { timers.forEach(window.clearInterval); });
 document.addEventListener('keydown', function(e) { if(e.key==='Escape') $('.ugc-close').trigger('click'); if ((e.key==='Enter' || e.key===' ') && e.target.matches('[data-vdo]')) { e.preventDefault(); $(e.target).trigger('click'); } });
 document.addEventListener('click', function(e) {
  const link = e.target.closest && e.target.closest('a.nrsm-review-link');
  if (!link) return;
  const reviews = document.getElementById('nrsm-loox-reviews');
  if (!reviews) return;
  e.preventDefault(); e.stopPropagation();
  reviews.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
 }, true);
})(window.NRSMjQuery);
